import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=5b97cf16&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Modal.vue?vue&type=style&index=1&id=5b97cf16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b97cf16",
  null
  
)

export default component.exports